<template>
  <div :style="height" class="black-bg pr ht-100x">
    <fo-homeTextSvgPc v-if="screenWidth>768"></fo-homeTextSvgPc>
    <fo-homeTextSvgMobile v-if="screenWidth<=768"></fo-homeTextSvgMobile>
    <div v-if="screenWidth<=768" class="home-landing-mobile white">
      <div ref="homeLittleTitle" class="landing-little-title tt-u pr transition-gentle bm--40 op-0" style="color: #FD4100;letter-spacing: 9px;">{{info.home_title}}</div>
      <div ref="homeTitle" class="pr bm--40 landing-title serif transition-lenear op-0 fw-400 white">
        <div class="dis-ib">{{info.home_title_1}}</div>
      </div>
      <div ref="homeSubtitle" class=" pr bm--80 landing-subtitle san-serif fs-14 mt-24 transition-lenear op-0" style="width: 75%;color:#F1F1F1;" v-html="info.home_subtitle"></div>
    </div>
    <div v-else class="home-landing-pc white wrapper">
      <div ref="homeLittleTitle" class="landing-little-title tt-u pr transition-gentle bm--40 op-0" style="color: #FD4100;letter-spacing: 9px;">{{info.home_title}}</div>
      <div ref="homeTitle" class="pr bm--40 landing-title serif transition-lenear op-0 fw-400 white">
        <div class="dis-ib">{{info.home_title_1}}</div>
      </div>
      <div ref="homeSubtitle" class="pr bm--80 landing-subtitle san-serif fs-14 transition-lenear op-0" style="color:#F1F1F1;" v-html="info.home_subtitle"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Landing',
  props: ['loading'],
  computed: {
    ...mapGetters([
      'screenHeight',
      'textInfo',
      'screenWidth'
    ]),
    height () {
      let num = this.screenHeight + 2
      let res = 'height: ' + num + 'px;'
      return res
    }
  },
  data () {
    return {
      info: {},
      mobileDivHeight: this.screenHeight
    }
  },
  watch: {
    loading (val) {
      if (val) {
        setTimeout(() => {
          this.$refs.homeTitle.style.opacity = 1
          this.$refs.homeTitle.style.bottom = 0
          this.$refs.homeSubtitle.style.opacity = 1
          this.$refs.homeSubtitle.style.bottom = 0
          this.$refs.homeLittleTitle.style.opacity = 1
          this.$refs.homeLittleTitle.style.bottom = 0
        }, 500)
      }
    },
    textInfo (val) {
      if (val) {
        this.info = this.$.s2o(val)
        this.$.s('textInfo', val)
      }
    },
    screenHeight () {
      if (this.screenWidth <= 768) {
        var divHeight = document.getElementById('home-landing-height')
        if (divHeight && divHeight.offsetHeight > this.screenHeight) {
          this.mobileDivHeight = divHeight.offsetHeight
        } else {
          this.mobileDivHeight = this.screenHeight
        }
      }
    }
  },
  mounted () {
    if (this.$.g('textInfo')) {
      this.info = this.$.s2o(this.$.g('textInfo'))
    }
    if (this.loading) {
      setTimeout(() => {
        this.$refs.homeTitle.style.opacity = 1
        this.$refs.homeTitle.style.bottom = 0
        this.$refs.homeSubtitle.style.opacity = 1
        this.$refs.homeSubtitle.style.bottom = 0
        this.$refs.homeLittleTitle.style.opacity = 1
        this.$refs.homeLittleTitle.style.bottom = 0
      }, 500)
    }
  },
  methods: {
  }
}
</script>
<style>
.home-landing-mobile {
  height: 300px;
  position: absolute;
  left: 0;
  bottom: 15%;
  padding: 0 20px;
  width: 100%;
}
.home-landing-pc {
  padding-right: 10%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.landing-little-title {
  font-size: 13px;
  margin-bottom: 8px;
}
.landing-title {
  bottom: -50px;
  font-size: 1.8em;
  line-height: 36px;
}
.landing-subtitle {
  font-size: 13px;
  line-height: 26px;
  margin-top: 20px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .landing-little-title {
    font-size: 14px;
    margin-bottom: 5px;
  }
  .landing-title {
    font-size: 30px;
  }
  .landing-subtitle {
    font-size: 14px;
    line-height: 22px;
    margin-top: 20px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .landing-little-title {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .landing-title {
    bottom: -50px;
    font-size: 36px;
  }
  .landing-subtitle {
    font-size: 14px;
    line-height: 22px;
    margin-top: 20px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .landing-little-title {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .landing-title {
    bottom: -50px;
    font-size: 42px;
    line-height: 54px;
  }
  .landing-subtitle {
    font-size: 18px;
    line-height: 30px;
    margin-top: 30px;
  }
  .landing-subtitle {
    font-size: 14px;
    line-height: 30px;
    margin-top: 40px;
    width: 60%;
  }
  .home-landing-pc {
    padding-right: 20%;
  }
}
@media screen and (min-width: 1920px) {
  .landing-little-title {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .landing-title {
    bottom: -50px;
    font-size: 46px;
    line-height: 60px;
    width: 75%;
  }
  .landing-subtitle {
    font-size: 16px;
    line-height: 30px;
    margin-top: 40px;
    width: 460px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Landing.vue